export default {
      id: "ssl-usage",
      viewBox: "0 0 29 30",
      url: __webpack_public_path__ + "img/icons.svg#ssl",
      toString: function () {
        return this.url;
      }
    }